export default __webpack_public_path__ + "static/media/our_solutions_drop-down.beba593d.svg";